ShowPrice = new (function () {
	this.button;
	this.visibleProducts = [];

	this.onSubmit = (event) => {
		event.preventDefault();

		const form = new FormData(event.target);
		form.append("action", "showprice_tracking");

		const cookieVisibleProducts = this.getCookie("visible-products");
		const productId = parseInt(form.get("product_id"));
		if (cookieVisibleProducts != "") {
			this.visibleProducts = JSON.parse(cookieVisibleProducts);
			if (!this.visibleProducts.includes(productId)) {
				this.visibleProducts.push(productId);
				this.setCookie("visible-products", JSON.stringify(this.visibleProducts), 30);
			}
		} else {
			this.visibleProducts.push(parseInt(productId));
			this.setCookie("visible-products", JSON.stringify(this.visibleProducts), 30);
		}

		const elPrice = event.target.parentElement.querySelector(".price");
		const sectionAddToCart = event.target.previousElementSibling;
		if (elPrice) {
			elPrice.innerHTML = atob(form.get("product_price"));
			if (sectionAddToCart) {
				sectionAddToCart.classList.remove("hidden");
			}
			event.target.remove();
		}

		fetch(EHTScripts.url.ajax, {
			body: form,
			credentials: "same-origin",
			headers: {
				Accept: "application/json",
			},
			method: "POST",
		})
			.then((resp) => {
				//console.log(resp);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	this.getCookie = function (cname) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	};

	this.setCookie = function (cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	};
})();
